import { GasSensorAnimatic } from '@crossnokaye/ux-animatics';

import {
  ANIMATIC_CRITICAL_VARIANT,
  ANIMATIC_DEFAULT_VARIANT,
  ANIMATIC_FAULTED,
  ANIMATIC_PRIMARY_LABEL,
  ANIMATIC_SECONDARY_LABEL,
} from '@/features/equipment-browser/animatics/constants';
import { getLabel } from '@/features/equipment-browser/animatics/helpers';

import { AnimaticConfigProps } from './types';
import { ScaledAnimatic } from '../scaled-animatic';

export const AnimaticGasSensor = ({
  config,
  labels,
  className,
}: Omit<AnimaticConfigProps, 'state'>) => {
  const variant =
    config.status == ANIMATIC_FAULTED ? ANIMATIC_CRITICAL_VARIANT : ANIMATIC_DEFAULT_VARIANT;

  const primaryLabel = getLabel(labels, ANIMATIC_PRIMARY_LABEL);
  const secondaryLabel = getLabel(labels, ANIMATIC_SECONDARY_LABEL);
  const gasType = config.specificAnimaticConfig?.gasSensor?.gasType ?? '';

  return (
    <ScaledAnimatic className={className} scaleX={1} scaleY={1}>
      <GasSensorAnimatic
        gasType={gasType}
        secondaryLabel={secondaryLabel?.text}
        primaryLabel={primaryLabel?.text}
        variant={variant}
      />
    </ScaledAnimatic>
  );
};
